import React from 'react';

import { Component } from '@poa/core';
import { observer, observable, action, Observer } from '@poa/state';
import LaddaButton, { XL, SLIDE_UP } from 'react-ladda';

import SynctoolIcon from '../components/icons/synctool';
import EyeIcon from '../components/icons/eye';

class PasswordField extends React.Component {
  static defaultProps = {
    name: 'password',
    placeholder: 'password'
  };

  isPasswordVisible = observable(false);

  togglePasswordVisibility = action(() =>
    this.isPasswordVisible.set(!this.isPasswordVisible.get())
  );

  render() {
    return (
      <div className="main-form__input main-form__pass" autoComplete="on">
        <input
          textContentType="password"
          type={this.isPasswordVisible.get() ? 'text' : 'password'}
          name={this.props.name}
          placeholder={this.props.placeholder}
          data-test-id={this.props.testId}
        />
        <button
          type="button"
          className="main-form__icon"
          onMouseDown={this.togglePasswordVisibility}
          onMouseUp={this.togglePasswordVisibility}
        >
          <EyeIcon />
        </button>
      </div>
    );
  }
}

PasswordField = observer(PasswordField);

class LoginPage extends React.Component {
  actions; // injected by Poa
  t; // injected by Poa

  localState = observable({ isSubmitting: false, isError: false });

  handleAuthFormSubmit = async event => {
    const { username, password } = event.target.elements;

    event.preventDefault();

    if (!username.value || !password.value) {
      this.localState.isError = true;
      setTimeout(() => (this.localState.isError = false), 1000);
      return;
    }

    this.localState.isSubmitting = true;
    this.localState.isError = false;

    try {
      await this.actions.authActions.logIn(username.value, password.value);
    } catch (e) {
      setTimeout(() => (this.localState.isError = true), 900);
    } finally {
      setTimeout(() => (this.localState.isSubmitting = false), 1000);
    }
  };

  render() {
    return (
      <div className="content">
        <div className="authorization">
          <div className="authorization__inner">
            <div className="logo logo-login">
              <SynctoolIcon />
            </div>
            <Observer>
              {() => (
                <div className={`authorization__box ${this.localState.isError ? 'shake' : ''}`}>
                  <div className="main-form">
                    <form name="auth_form" onSubmit={this.handleAuthFormSubmit}>
                      <div className="main-form__input">
                        <input
                          type="text"
                          name="username"
                          placeholder="login"
                          data-test-id="loginField"
                          textContentType="username"
                        />
                      </div>
                      <PasswordField
                        name="password"
                        placeholder="password"
                        testId="passwordField"
                      />
                      <Observer>
                        {() => (
                          <LaddaButton
                            className="main-form__submit"
                            loading={this.localState.isSubmitting}
                            type="submit"
                            data-test-id="submitButton"
                            data-color="#eee"
                            data-size={XL}
                            data-style={SLIDE_UP}
                            data-spinner-size={30}
                            data-spinner-color="#ddd"
                            data-spinner-lines={12}
                          >
                            {this.t('enter')}
                          </LaddaButton>
                        )}
                      </Observer>
                    </form>
                  </div>
                </div>
              )}
            </Observer>
          </div>
        </div>
      </div>
    );
  }
}

export default Component({ namespaces: ['login'] })(LoginPage);
